import*as React from'react';var ReportDetailPaneCardParagrah=function ReportDetailPaneCardParagrah(props){return<>
    <p className="card-text mb-0"style={{fontSize:'14px'}}>
      <span className="mr-2">{props.label}</span>:<span className="ml-2">{props.children}</span>
    </p>
  </>;};export default ReportDetailPaneCardParagrah;